import { DefaultError, useMutation } from "@tanstack/react-query";
import { CardBlockImage } from "entities/modules/types";
import { getImageKey } from "entities/modules/utils";
import { updatePageModule } from "entities/pages/api/updatePageModule";
import { PageModuleDataToUpdate } from "entities/pages/types";
import { PAGE_THREE_CARDS_BLOCKS } from "modules/brands/pages/ModulesContainer/components/PageModules/components/ModuleDetailsDrawer/context/constants";
import { invalidateImageFilesQueries } from "shared/queries/useImageFileQueries";
import { MODULE_TOP_PRIVACY_TIPS_BLOCK } from "../../../modules/moduleTemplates/components/ModuleDetailsDrawer/context/constants";
import {
  getAllBrandsWithAllModulesQueryData,
  invalidateAllBrandsWithAllModulesQuery,
  setAllBrandsWithAllModulesQueryData,
} from "../queries/useAllBrandsWithAllModulesQuery";

type Params = {
  moduleId: string;
  moduleData: PageModuleDataToUpdate;
  brandId: string;
  pageId: string;
  cardBlockImages: CardBlockImage[];
  topPrivacyTipsBlockImage: CardBlockImage;
};

export const useUpdateContentModuleMutation = () => {
  return useMutation<void, DefaultError, Params>({
    mutationFn: async (params) => {
      await updatePageModule(params);
    },
    onSuccess: (
      _,
      { moduleData, cardBlockImages, moduleId, topPrivacyTipsBlockImage },
    ) => {
      const allModules = getAllBrandsWithAllModulesQueryData();

      if (allModules) {
        const updatedModules = allModules.map((module) =>
          module.id === moduleId ? { ...module, ...moduleData } : module,
        );

        setAllBrandsWithAllModulesQueryData(updatedModules);
        invalidateAllBrandsWithAllModulesQuery();
      }

      if (cardBlockImages.some((item) => item instanceof File)) {
        cardBlockImages.forEach((image, index) => {
          if (image) {
            const imageQueryKey = getImageKey(PAGE_THREE_CARDS_BLOCKS, index);
            invalidateImageFilesQueries([[imageQueryKey, moduleId]]);
          }
        });
      }

      if (topPrivacyTipsBlockImage) {
        const imageQueryKey = `${MODULE_TOP_PRIVACY_TIPS_BLOCK}-image`;
        invalidateImageFilesQueries([[imageQueryKey, moduleId]]);
      }
    },
    onError: (e) => {
      console.error("Error occurred when updating content module", e);
    },
  });
};
